/* eslint-disable no-console */
import Rollbar from 'rollbar';
import { ROLLBAR_ACCESS_TOKEN } from 'config/constants';

const rollbar = new Rollbar({
  accessToken: ROLLBAR_ACCESS_TOKEN,
  enabled: process.env.NODE_ENV === 'production',
  captureUncaught: true,
  captureUnhandledRejections: true,
  logLevel: 'info',
  reportLevel: 'info',
  payload: {
    environment: process.env.NODE_ENV,
    code_version: process.env.COMMITHASH,
    source_map_enabled: true,
    client: {
      javascript: {
        environment: process.env.NODE_ENV,
        code_version: process.env.COMMITHASH,
        source_map_enabled: true,
        guess_uncaught_frames: true,
      },
    },
  },
});

const originalConsoleError = console.error;
// eslint-disable-next-line func-names
console.error = function (message, error) {
  rollbar.error(message, error);

  // eslint-disable-next-line prefer-rest-params
  originalConsoleError.apply(this, arguments);
};

const originalConsoleWarning = console.warn;
// eslint-disable-next-line func-names
console.warn = function (message, error) {
  rollbar.warn(message, error);

  // eslint-disable-next-line prefer-rest-params
  originalConsoleWarning.apply(this, arguments);
};

console.rollbar = rollbar;



// WEBPACK FOOTER //
// ./app/config/rollbar.js